<script>

    export let text = ''
    export let size = '3'

</script>

<div class="title is-{ size }">{ text }</div>